import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FGPurityForm from '../../../../components/masters/metalPurity/fgPurity/FGPurityForm';
import FGPurityTable from '../../../../components/masters/metalPurity/fgPurity/FGPurityTable';
import { fetchFGPurities, addFGPurity, updateFGPurity, deleteFGPurity, setFGPurityEdit, clearFGPurityEdit } from '../../../../redux/actions/masters/metalPurity/fgPurity/fgPurityAction';
import { fetchCompanies } from '../../../../api/masters/company/companyApi';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .fg-purity-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .fg-purity-form, .fg-purity-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const FGPurityPage = () => {
  const dispatch = useDispatch();
  const { list = [], loading, editingFGPurity, formSuccess, formError } = useSelector(state => state.fgPurity || {});
  const users = useSelector(state => state.users.list || []);
  const [companies, setCompanies] = useState([]);
  const [formSuccessMsg, setFormSuccessMsg] = useState('');
  const [formErrorMsg, setFormErrorMsg] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchFGPurities());
    dispatch(fetchUsers());
    fetchCompanies().then(data => setCompanies(data.filter(c => c.trash === 0)));
  }, [dispatch]);

  useEffect(() => {
    setFormSuccessMsg(formSuccess || '');
  }, [formSuccess]);
  useEffect(() => {
    setFormErrorMsg(formError || '');
  }, [formError]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccessMsg('');
    setFormErrorMsg('');
    dispatch(clearFGPurityEdit());
  };

  const handleSubmit = async (form) => {
    if (editingFGPurity && editingFGPurity.fg_purity_id) {
      await dispatch(updateFGPurity(editingFGPurity.fg_purity_id, form));
      setFormErrorMsg('');
    } else {
      await dispatch(addFGPurity(form));
      setFormErrorMsg('');
    }
  };

  const handleEdit = (fgPurity) => {
    dispatch(setFGPurityEdit(fgPurity));
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  const handleDelete = (id) => {
    dispatch(deleteFGPurity(id));
  };

  const handleCancel = () => {
    dispatch(clearFGPurityEdit());
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  // Uniqueness check for code (used in form)
  const checkCodeExists = async (code, excludeId) => {
    const match = list.find(
      fg => fg.purity_code === code && (!excludeId || fg.fg_purity_id !== excludeId)
    );
    return !!match;
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="fg-purity-flex">
        <div style={tableContainer} className="fg-purity-table">
          <FGPurityTable
            onNew={handleFormReset}
            fgPurities={list}
            onEdit={handleEdit}
            onDelete={handleDelete}
            loading={loading}
          />
        </div>
        <div style={formContainer} className="fg-purity-form">
          <FGPurityForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingFGPurity={editingFGPurity}
            onCancel={handleCancel}
            formSuccess={formSuccessMsg}
            formError={formErrorMsg}
            setFormSuccess={setFormSuccessMsg}
            setFormError={setFormErrorMsg}
            companies={companies}
            users={users}
            checkCodeExists={checkCodeExists}
          />
        </div>
      </div>
    </div>
  );
};

export default FGPurityPage; 